import { Box, styled } from '@material-ui/core';

export const Container = styled(Box)({
  flex: 1,
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between'
});

export const Content = styled(Box)({
  display: 'flex',
  flex: 1
});

export const Footer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(2, 4, 3, 4)
}));
